import Wrapper from "../../helpers/Wrapper"
import "./card.scss"
import PropTypes from "prop-types";


const Card = ({ children, className = "", style = {} }) => {
    return (
        <Wrapper>
            <div className={`card ${className}`} style={style}>
                {children}
            </div>
        </Wrapper>
    );
};
Card.Header = ({ children }) => {
    return (
        <Wrapper>
            <div className="card-header">
                {children}
            </div>
        </Wrapper>
    );
};

Card.HeaderWrap = ({ children }) => {
    return (
        <Wrapper>
            <div className="title-wrapper">
                {children}
            </div>
        </Wrapper>
    );
}

Card.Header.Title = ({ children }) => {
    return (
        <Wrapper>
            <h2>{children}</h2>
        </Wrapper>
    );
};

Card.Header.Dropdowns = ({ children }) => {
    return (
        <Wrapper>
            <div className="dropdowns">
                {children}
            </div>
        </Wrapper>
    );
};

Card.Body = ({ children }) => {
    return (
        <Wrapper>
            <div className="card-body">
                {children}
            </div>
        </Wrapper>
    );
};

Card.Footer = ({ children }) => {
    return (
        <Wrapper>
            <div className="card-footer">
                {children}
            </div>
        </Wrapper>
    );
};

Card.propTypes = {
    children: PropTypes.any
}


export default Card;
